import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'

const child = [
    {
        path:'dashboard',
        name:'Dashboard',
        component:Dashboard,
        replace:true,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path:"/time-recording",
        name:"TimeRecording",
        component:()=>import('@/components/pages/time-recording/TimeRecording'),
        meta: { requiresAuth: true }
    },
    {
        path: "/time-recording-approval",
        name:"TimeRecordingApproval",
        component: ()=> import('@/components/pages/time-recording/TimeRecordingApproval'),
        props:route => ({ emp_id: route.query.emp_id, period:route.query.period }),
        meta: { requiresAuth: true }
    },
    {
        path:"/leave-request",
        name:"LeaveRequest",
        component:()=> import('@/components/pages/leave-request/LeaveRequest'),
        meta: { requiresAuth: true}
    },
    {
        path:"/travel-request",
        name :"TravelRequest",
        component: ()=> import('@/components/pages/travel-request/TravelRequest'),
        meta: { requiresAuth: true }
    },
    {
        path:"/travel-request-input",
        name:"TravelRequestInput",
        component:() => import('@/components/pages/travel-request/TravelRequestInput'),
        meta: { requiresAuth: true }
    },
    {
        path:"/travel-request-detail",
        name:"TravelRequestDetail",
        component:() => import('@/components/pages/travel-request/TravelRequestDetail'),
        meta: { requiresAuth: true }
    },
    {
        path:"/cash-advance-request",
        name:"CashAdvance",
        component: ()=> import('@/components/pages/cash-advance/CashAdvance'),
        meta: { requiresAuth: true }
    },
    {
        path: "/cash-advance-input",
        name:"CashAdvanceInput",
        component: () => import('@/components/pages/cash-advance/CashAdvanceInput'),
        meta: { requiresAuth: true }
    },
    {
        path: "/work-from-home",
        name:"WorkFromHome",
        component: () => import('@/components/pages/work-from-home/WorkFromHome'),
        meta: { requiresAuth: true }
    },
    {
        path:"/work-from-home-input",
        name: "WorkFromHomeInput",
        component: () => import('@/components/pages/work-from-home/WorkFromHomeInput'),
        meta: { requiresAuth: true }
    },
    {
        path: "/compensatory-overtime",
        name:"CompensatoryOvertime",
        component: ()=> import('@/components/pages/compensatory-overtime/CompensatoryOvertime'),
        meta: { requiresAuth: true }
    },
    {
        path: "/compensatory-overtime-input",
        name:"CompensatoryOvertimeInput",
        component: () => import('@/components/pages/compensatory-overtime/CompensatoryOvertimeInput'),
        meta: { requiresAuth: true }
    },
    {
        path: "/compensatory",
        name:"Compensatory",
        component: () => import('@/components/pages/compensatory/Compensatory'),
        meta: { requiresAuth: true }
    },
    {
        path: "/compensatory-input",
        name:"CompensatoryInput",
        component: () => import('@/components/pages/compensatory/CompensatoryInput'),
        meta: { requiresAuth: true }
    },
    {
        path:"/staff",
        name:"Staff",
        component: () => import('@/components/pages/staff/Staff'),
        meta: { requiresAuth: true }
    },
    {
        path: "/staff-input",
        name:"StaffInput",
        component: () => import('@/components/pages/staff/StaffInput'),
        meta: { requiresAuth: true }
    },
    {
        path: "/employee",
        name: "Employee",
        component: ()=> import('@/components/pages/employee/Employee'),
        meta: { requiresAuth: true }
    },
    {
        path: "/employee-edit",
        name: "EmployeeInput",
        component: () => import('@/components/pages/employee/EmployeeInput'),
        replace:true,
        meta: { requiresAuth: true }
    },
    {
        path: "/employee-status",
        name: "EmployeeStatusIndex",
        component: () => import('@/components/pages/employee-status/EmployeeStatusIndex')
    },
    {
        path: "/submit-time-recording",
        name:"SubmitTimeRecording",
        component: ()=> import('@/components/pages/time-recording/SubmitTimeRecording'),
        meta: { requiresAuth: true }
    },
    {
        path: "/time-recording-list",
        name:"ListTimeRecording",
        component: ()=> import('@/components/pages/time-recording/ListTimeRecording'),
        meta: { requiresAuth: true }
    },
    {
        path:"/detail-news",
        name:"DetailNews",
        component: ()=> import('@/components/pages/news/DetailNews'),
        meta: { requiresAuth: true },
        replace:true,
        // props:route => ({ id: route.query.id }),
    },
    {
        path:"/detail-event",
        name:"DetailEvent",
        component: ()=> import('@/components/pages/event/DetailEvent'),
        meta: { requiresAuth: true },
        replace:true,
        props:route => ({ id: route.query.id }),
    },
    {
        path:"/policy-regulation",
        name:"PolicyRegulation",
        component: ()=> import('@/components/pages/intranet/PolicyRegulation'),
        meta: {requiresAuth:true}
    },
    {
        path:"/picture-gallery",
        name:"PictureGallery",
        component: () => import('@/components/pages/intranet/PictureGallery'),
        meta: {requiresAuth:true}
    },
    {
        path:"/video-gallery",
        name:"VideoGallery",
        component: () => import('@/components/pages/intranet/VideoGallery'),
        meta: {requiresAuth:true}
    },
    {
        path:"/contact-list",
        name:"ContactList",
        component: () => import('@/components/pages/intranet/ContactList'),
        meta: {requiresAuth:true}
    },
    {
        path:"/career",
        name:"CareerIndex",
        component: ()=> import('@/components/pages/news/CareerIndex'),
        meta: {requiresAuth:true}
    },
    {
        path:"/career-detail",
        name:"CareerDetail",
        component: () => import('@/components/pages/news/CareerDetail'),
        meta: {requiresAuth:true}
    },
    {
        path:"/notifications",
        name:"NotificationsIndex",
        component: () => import('@/components/pages/notifications/NotificationsIndex'),
        meta: {requiresAuth:true},
        replace:true,
    },
    {
        path:"/overtime",
        name:"OvertimeIndex",
        component: ()=>import('@/components/pages/overtime/OvertimeIndex'),
        meta: {requiresAuth: true}
    }
];

const routes = [
    {
        path:"/login",
        name:"Login",
        component:()=> import('@/components/Login'),
        meta: {
            requiresAuth: false,
        }
    },
    {
        path:"/forgot-password",
        name:"ForgotPassword",
        component:()=>import('@/components/ForgotPassword'),
        meta: { requiresAuth: false }
    },
    {
        path:"/change-password",
        name:"ChallengePassword",
        component:()=>import('@/components/ChallengePassword'),
        meta: { requiresAuth: false, }
    },
    {
        path:"*",
        name:"NotFound",
        component: ()=> import('@/components/NotFound'),
        meta: { requiresAuth: false,}
    },
    {
        path:"/logout",
        name:"Logout",
        meta: { requiresAuth: false,}
    },
    {
        path: '/',
        redirect: () =>{return '/dashboard'} ,
        name: 'Home',
        component: ()=> import('@/components/layout/Container'),
        meta: { requiresAuth: true, isDynamic:true },
        children:[]
    }
];

const extractArray = (arr)=>{
    return arr.map(a => {
        if(a.children?.length > 0){
            return extractArray(a.children)
        }else{
            return a.path
        }
    })
}
let allowChildAccess = store.state.menus.map(a => {
    if(a.children?.length > 0){
        return extractArray(a.children)
    }else{
        return a.path
    }
}).flat(Infinity);

if(allowChildAccess.length > 0){
   let idx = routes.findIndex(x=>x.path === '/')
   child.forEach((value)=>{
       if(allowChildAccess.includes(value.path)){
           routes[idx].children.push(value)
       }
   })
}

Vue.use(Router)

export const router =  new Router({
    mode: 'history',
    routes: routes
})

router.beforeEach(async(to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        let isAuth = await store.getters.isAuthenticated

        if (isAuth) {
            store.commit("SET_PAGE", to)
           await next()
        }else{
           await router.push({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        }
    }else{
        if(to.path == "/logout"){
            store.commit("AUTH_LOGOUT")
            await router.push({
                path: '/login'
            })
        }
         await next(); // make sure to always call next()!
    }

})
